import React, { useEffect, useState } from 'react'

const CustomSwitch = ({ on, bgColor}) => {

    const [isOn, setIsOn] = useState(false)

    // useEffect(() => {
    //     console.log("switchON:", on);

    //     // if (on) {
    //     //     setIsOn(on)
    //     // }
    // }, [on])

    // const handleToggle = () => {


    //     if (multipleSwitch && setMultipleSwitch) {

    //         setMultipleSwitch((prevState) => {

    //             prevState[index] = {
    //                 ...prevState[index],
    //                 on: !isOn
    //             }

    //             return prevState
    //         });

    //         setIsOn(!isOn);
    //     }


    // }

    return (
        <div style={{ display: 'inline-block', padding: '10px', width: "100%", height: "100%" }}>
            <label style={{ position: 'relative', display: 'inline-block', width: '100%', height: '100%' }}>
                <input
                    type="checkbox"
                    checked={on}
                    // onChange={handleToggle}
                    style={{ opacity: 0, width: 0, height: 0 }}
                />
                <span style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: on && bgColor ? bgColor : '#ccc',
                    transition: '.4s',
                    borderRadius: '30px',
                }}>
                    <span style={{
                        position: 'absolute',
                        content: '',
                        height: '24px',
                        width: '24px',
                        left: on ? '32px' : '4px',
                        bottom: '3px',
                        backgroundColor: 'white',
                        transition: '.4s',
                        borderRadius: '50%',
                    }} />
                </span>
            </label>

        </div>
    )
}

export default CustomSwitch;